import script from "./Student.vue?vue&type=script&setup=true&lang=js"
export * from "./Student.vue?vue&type=script&setup=true&lang=js"

import "./Student.vue?vue&type=style&index=0&id=073393b0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-073393b0"]])

export default __exports__